import { render, staticRenderFns } from "./PaymentGatewayList.vue?vue&type=template&id=6fa3961e&scoped=true&"
import script from "./PaymentGatewayList.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa3961e",
  null
  
)

export default component.exports